import api from "./api";

export const clienteService = {
  getAll: async () => {
    const response = await api.get("/clientes");
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/clientes/${id}`);
    return response.data;
  },

  create: async (clienteData) => {
    const response = await api.post("/clientes", clienteData);
    return response.data;
  },

  update: async (clienteData) => {
    const response = await api.put(`/clientes/${clienteData.id}`, clienteData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/clientes/${id}`);
    return response.data;
  },

  // Búsqueda rápida para selects
  search: async (query) => {
    const response = await api.get(
      `/clientes?search=${encodeURIComponent(query)}`,
    );
    return response.data;
  },
};
